import { get } from 'svelte/store';
import { api } from '../../../../stores/api';

import { VehiclesApi } from '../VehiclesApi';
import ModalError from '../../../shared/Modals/ModalError.svelte';
import { Vehicle } from '../Vehicle';
import { Api } from '@automapa/svelte-automapa-template';
import { openModal } from 'svelte-modals';
import type { AsyncAppInterface } from '../../Planning/PageDeliveries2/DeliveryListApp/AsyncAppInterface';

export class VehiclesApp implements AsyncAppInterface<Vehicle> {
    items: Vehicle[] = [];
    api: Api = get(api);
    loaded: boolean = false;

    async load() {
        if (this.loaded) {
            return;
        }
        let vehiclesResponse = await VehiclesApi.getAll(this.api, null).catch(e => {
            console.error(e);
            openModal(ModalError, { title: 'Error', message: 'Failed to load vehicles' });
            return [];
        });
        this.items = vehiclesResponse.map(v => new Vehicle().set(v));
        this.loaded = true;
    }

    async reloadOne(id: number): Promise<this> {
        let vehicleResponse = await VehiclesApi.getOne(this.api, id).catch(e => {
            console.error(e);
            openModal(ModalError, { header: 'Error', message: 'Failed to load vehicle' });
            return null;
        });
        if (vehicleResponse) {
            let vehicle = this.items.find(v => v.getId() === id);
            if (vehicle) {
                vehicle.set(vehicleResponse);
            }
        }
        return this;
    }

    async setColor(id: number, color: string): Promise<this> {
        let vehicleResponse = await VehiclesApi.patch(this.api, id, 'color', color).catch(e => {
            console.error(e);
            openModal(ModalError, { header: 'Error', message: 'Failed to update vehicle' });
            return null;
        });
        if (vehicleResponse) {
            let vehicle = this.items.find(v => v.getId() === id);
            if (vehicle) {
                vehicle.set(vehicleResponse);
            }
        }
        return this;
    }

    async triggerReload() {
        await this.reset();
        await this.load();
    }

    async reset() {
        this.loaded = false;
    }

    async asyncGetItems(is_group: boolean | null = null) {
        if (!this.loaded) {
            await this.load();
        }
        return this.getItems(is_group);
    }

    async prepareData(): Promise<boolean> {
        console.log('prepareData, vehicles');
        if (!this.loaded) {
            await this.load();
        }
        return true;
    }

    getItems(is_group: boolean | null = null): Vehicle[] {
        if (is_group === null) {
            return this.items;
        }
        return this.items.filter(v => v.get()?.is_group === is_group);
    }

    setVehicleGroups(vehicleId: number, groupIds: number[]): Promise<any> {
        return VehiclesApi.setVehicleGroups(this.api, vehicleId, groupIds);
    }

    setVehiclesInGroup(groupId: number, vehicleIds: number[]): Promise<any> {
        return VehiclesApi.setVehiclesInGroup(this.api, groupId, vehicleIds);
    }

    getSelectItems(is_group: boolean | null = null): { id: string; label: string }[] {
        let items = this.getItems(is_group)
            .map(v => ({ id: v?.getId()?.toString() ?? '', label: v.getName() }))
            .filter(v => v.id !== '')
            .sort((a, b) => a.label.localeCompare(b.label));
        console.log('getSelectItems', items);
        return items;
    }

    getSelectItemsVehiclesOnly(): { id: string; label: string }[] {
        return this.getSelectItems(false);
        // let items = this.getItems(false)
        //     .map(v => ({ id: v?.getId()?.toString() ?? '', label: v.getName() }))
        //     .filter(v => v.id !== '')
        //     .sort((a, b) => a.label.localeCompare(b.label));
        // console.log('getSelectItemsVehiclesOnly', items);
        // return items;
    }

    getById(id: number): Vehicle | null {
        return this.items.find(v => v.getId() === id) ?? null;
    }

    async getUniqueVehicleIds(ids: number[]): Promise<number[]> {
        return VehiclesApi.getUniqueVehicleIds(this.api, ids);
    }
}
